"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationStatusReason = void 0;
var OrganizationStatusReason;
(function (OrganizationStatusReason) {
    OrganizationStatusReason["NegotiatedPaymentSchedule"] = "Negotiated Payment Schedule";
    OrganizationStatusReason["TestAccount"] = "Test / Sandbox Account";
    OrganizationStatusReason["PaymentApplicationPending"] = "Payment Application Pending";
    OrganizationStatusReason["ChurnRisk"] = "Churn Risk";
    OrganizationStatusReason["OpenDispute"] = "Open Dispute";
    OrganizationStatusReason["Suspended"] = "Suspended";
    OrganizationStatusReason["ExceedingDueTolerance"] = "Exceeding Due Tolerance";
    OrganizationStatusReason["Offboarded"] = "Offboarded";
})(OrganizationStatusReason = exports.OrganizationStatusReason || (exports.OrganizationStatusReason = {}));
//# sourceMappingURL=OrganizationStatusReason.js.map